// Elemente, die der CKEditor mit "contentConfigWithoutFormatting" erzeugen kann
const ALLOWED_TAGS = ["P", "H2", "STRONG", "I", "UL", "LI", "BLOCKQUOTE", "BR"];

// Druckregeln: Überschriften -> Zwischenüberschrift, Nummerierung -> Aufzählung
const RENAMED_TAGS = {
  B: "STRONG",
  EM: "I",
  H1: "H2",
  H3: "H2",
  H4: "H2",
  H5: "H2",
  H6: "H2",
  OL: "UL"
};

// Druckregel: Tabellen werden nicht gedruckt
const REMOVED_SELECTOR =
  "table, figure, img, script, style, iframe, video, audio";

const BLOCK_CONTAINER_TAGS = [
  "DIV",
  "BLOCKQUOTE",
  "PRE",
  "SECTION",
  "ARTICLE",
  "HEADER",
  "FOOTER"
];
const BLOCK_SELECTOR =
  "p, h1, h2, h3, h4, h5, h6, ul, ol, li, div, blockquote, pre, section, article, header, footer";

// Druckregel: 2. Aufzählungsebene -> 1. Ebene
function flattenNestedLists(root) {
  let nestedList = root.querySelector("li > ul, li > ol");
  while (nestedList) {
    const parentItem = nestedList.parentElement;
    let insertAfter = parentItem;
    [...nestedList.children].forEach(child => {
      insertAfter.after(child);
      insertAfter = child;
    });
    nestedList.remove();
    if (!parentItem.textContent.trim()) {
      parentItem.remove();
    }
    nestedList = root.querySelector("li > ul, li > ol");
  }
}

function sanitizeChildren(source, target, doc) {
  [...source.childNodes].forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      target.appendChild(doc.createTextNode(node.textContent));
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    let tagName = RENAMED_TAGS[node.tagName] || node.tagName;
    if (
      BLOCK_CONTAINER_TAGS.includes(tagName) &&
      tagName !== "BLOCKQUOTE" &&
      !node.querySelector(BLOCK_SELECTOR)
    ) {
      tagName = "P";
    }

    if (ALLOWED_TAGS.includes(tagName)) {
      const element = doc.createElement(tagName);
      sanitizeChildren(node, element, doc);
      target.appendChild(element);
      return;
    }

    // Nicht erlaubte Elemente (z. B. Unterstreichung, Links) -> normaler Text
    sanitizeChildren(node, target, doc);
  });
}

/**
 * Wendet die Druckregeln (ohne Trennungsregeln) auf HTML an und lässt nur
 * Elemente übrig, die in einem Kanal ohne Textformatierungen erlaubt sind.
 */
export function applyPrintRulesToHtml(html) {
  if (!html?.length) {
    return html || "";
  }

  const doc = new DOMParser().parseFromString(
    `<body>${html}</body>`,
    "text/html"
  );
  const source = doc.body;
  source.querySelectorAll(REMOVED_SELECTOR).forEach(node => node.remove());
  flattenNestedLists(source);

  const target = doc.createElement("body");
  sanitizeChildren(source, target, doc);
  return target.innerHTML;
}
